import { render, staticRenderFns } from "./ApplicationCollaborators.vue?vue&type=template&id=5eebb8d9&"
import script from "./ApplicationCollaborators.vue?vue&type=script&lang=ts&"
export * from "./ApplicationCollaborators.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports